import React, {useState} from "react";
import cx from "classnames";
import {ConfirmationModal} from "@components/elements/ConfirmationModal";

export function ResetFilterButton(props: { onReset: () => void, className?: string, askConfirmation?: boolean, enabled?: boolean }) {
    const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
    return (<>
        <button
            onClick={() => {
                if (props.askConfirmation) {
                    setIsConfirmationOpen(true);
                } else {
                    props.onReset();
                }
            }}
            className={cx("flex items-center justify-center rounded-full", "text-red-500 dark:text-red-500", "disabled:text-gray-400 dark:disabled:text-gray-500", "text-sm font-medium tracking-wider", props.className)}
            disabled={!props.enabled}
        >
            Reset
        </button>
        {props.askConfirmation && <ConfirmationModal
            isOpen={isConfirmationOpen}
            onClose={() => setIsConfirmationOpen(false)}
            onConfirm={() => {
                props.onReset();
                setIsConfirmationOpen(false);
            }}
        />}
    </>);
}